module.exports = "/_next/static/images/gma-e0bb8435a0d0a62f0a5736e540bcdeab.svg";